import { useNavigate } from 'react-router-dom';
import { EMAIL_TEXT } from '../../constants';

export default function CookiePolicy() {
  const navigate = useNavigate();
  return (
    <main style={{ maxWidth: 900, margin: '40px auto', padding: 24, lineHeight: 1.6 }}>
      <h1>Политика cookie</h1>
      <p>
        <strong>Версия:</strong> v1.0 · <strong>Сервис:</strong> savetorich
      </p>

      <p>
        Используем только <strong>технически необходимые</strong> cookie и иные технологии хранения
        на устройстве (сессия входа, защита CSRF). Аналитические и рекламные cookie{' '}
        <strong>не применяются</strong>.
      </p>

      {/* <h2>Состав необходимых cookie</h2> */}
      {/* <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ccc', padding: 8 }}>Имя</th>
              <th style={{ border: '1px solid #ccc', padding: 8 }}>Назначение</th>
              <th style={{ border: '1px solid #ccc', padding: 8 }}>Тип</th>
              <th style={{ border: '1px solid #ccc', padding: 8 }}>Срок</th>
              <th style={{ border: '1px solid #ccc', padding: 8 }}>Источник</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ border: '1px solid #ccc', padding: 8 }}>
                <code>sid</code> (пример — замените)
              </td>
              <td style={{ border: '1px solid #ccc', padding: 8 }}>
                Поддержание сессии авторизованного пользователя
              </td>
              <td style={{ border: '1px solid #ccc', padding: 8 }}>Первая сторона</td>
              <td style={{ border: '1px solid #ccc', padding: 8 }}>Сеанс/до 7 дней</td>
              <td style={{ border: '1px solid #ccc', padding: 8 }}>savetorich</td>
            </tr>
            <tr>
              <td style={{ border: '1px solid #ccc', padding: 8 }}>
                <code>csrf_token</code> (пример — замените)
              </td>
              <td style={{ border: '1px solid #ccc', padding: 8 }}>Защита от CSRF</td>
              <td style={{ border: '1px solid #ccc', padding: 8 }}>Первая сторона</td>
              <td style={{ border: '1px solid #ccc', padding: 8 }}>до 24 часов</td>
              <td style={{ border: '1px solid #ccc', padding: 8 }}>savetorich</td>
            </tr>
          </tbody>
        </table>
      </div> */}

      <h2>Управление cookie</h2>
      <p>
        Удалить/заблокировать cookie можно в настройках браузера. Блокировка необходимых cookie
        может нарушить работу входа и безопасности.
      </p>

      <hr />
      <small>
        Контакты по вопросам cookie/ПДн: <a href={`mailto:` + EMAIL_TEXT}>{EMAIL_TEXT}</a>.
      </small>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
        <button
          onClick={() => navigate('/')}
          className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition"
        >
          Вернуться на главную
        </button>
      </div>
    </main>
  );
}
